import { globalLogger } from '../../../qaamgo/helper/global-logger';

if (global.MODULE_LOADED_PROTECT_PDF) {
    globalLogger.log('double import');
} else {
    global.MODULE_LOADED_PROTECT_PDF = true;

    import(
        /* webpackMode: "eager" */
        '../qg-feature'
    ).then(function () {
        var pwdUserSuccess = false;
        var pwdOwnerSuccess = false;

        $(document).ready(function () {
            var permissionsInputs = $("input[name^='allow_']");
            var ownerPasswordPanel = $('#owner_password_panel');

            var updateInputFields = function () {
                if (permissionsInputs.filter(':checked').length > 0) {
                    ownerPasswordPanel.find('input[type=password]').prop('disabled', false);
                } else {
                    ownerPasswordPanel.find('input[type=password]').prop('disabled', true);
                }
            };

            permissionsInputs.click(updateInputFields);

            updateInputFields();
        });

        $(document).on('click', '.submit-btn', function (event) {
            //If user checked rasterize but did not provide any passwords
            if (
                $('input[name=rasterize_dpi]').is(':checked') &&
                $('#u_new_password').val() === '' &&
                $('#new_password').val() === ''
            ) {
                $('input[name=allow_printing],input[name=allow_copying], input[name=allow_modification]').attr(
                    'data-option-ignore',
                    true
                );
                qgFeaturePage.defaultSubmit();
                return;
            }

            if (validateProtectPDFForm()) {
                qgFeaturePage.defaultSubmit();
            }
        });

        function validateProtectPDFForm() {
            $('.form-group').each(function () {
                $(this).removeClass('has-error');
            });

            var _log = $.noop;

            if (typeof ocErrLog === 'object' && ocErrLog.hasOwnProperty('log') && typeof ocErrLog.log === 'function') {
                _log = ocErrLog.log;
            }

            var userPassword = $('#u_new_password').val(),
                userRepeatPassword = $('#u_confirm_password').val(),
                permissionsInputs = $("input[name^='allow_']");
            if (permissionsInputs.filter(':checked').length === 0) {
                return userPasswordCheck();
            }

            if (permissionsInputs.filter(':checked').length > 0) {
                if (userPassword != '' || userRepeatPassword != '') {
                    if (userPasswordCheck()) {
                        return ownerPasswordCheck();
                    }

                    return userPasswordCheck();
                }

                return ownerPasswordCheck();
            }
        }

        function userPasswordCheck() {
            $('.new_passwordErr').addClass('hidden');
            $('.confirm_passwordErr').addClass('hidden');
            
            var userPassword = $('#u_new_password').val(),
            userRepeatPassword = $('#u_confirm_password').val(),
            
            // allow only printable characters from latin-1
            regex = /^[\u0021-\u007e|\u00a1-\u00ff]+$/;
            
            if (userPassword == '' && userRepeatPassword == '') {
                $('.u_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_new_password').css('border-color', '#dd4b39');
                
                $('.u_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter open password'))
                    .parents('.form-group')
                    .addClass('has-error');
                $('#u_confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (userPassword == '') {
                $('.u_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_new_password').css('border-color', '#dd4b39');
                
                $('.u_confirm_passwordErr').addClass('hidden');
                $('#u_confirm_password').css('border-color', '');
                
                return false;
            } else if (userRepeatPassword == '') {
                $('.u_new_passwordErr').addClass('hidden');
                $('#u_new_password').css('border-color', '');

                $('.u_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter open password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_confirm_password').css('border-color', '#dd4b39');
                
                return false;
            } else if (userPassword.length > 32) {
                $('.u_confirm_passwordErr').addClass('hidden');
                $('#u_confirm_password').css('border-color', '');

                $('.u_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please enter open password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' })
                $('#u_new_password').css('border-color', '#dd4b39');

                return false;
            } else if (userRepeatPassword.length > 32) {
                $('.u_new_passwordErr').addClass('hidden');
                $('#u_new_password').css('border-color', '');

                $('.u_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please repeat open password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (userPassword != '' && userRepeatPassword != '' && userPassword !== userRepeatPassword) {
                $('.u_new_passwordErr').addClass('hidden');
                $('#u_new_password').css('border-color', '');

                $('.u_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Open password did not match'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (!regex.test(userPassword) == true) {
                $('.u_new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Invalid password. Only uppercase and lowercase characters, numbers, hyphens and underscores allowed.'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#u_new_password').css('border-color', '#dd4b39');

                $('.u_confirm_passwordErr').addClass('hidden');
                $('#u_confirm_password').css('border-color', '');

                return false;
            } else {
                pwdUserSuccess = true;
                return true;
            }
        }

        function ownerPasswordCheck() {
            $('.u_new_passwordErr').addClass('hidden');
            $('.u_confirm_passwordErr').addClass('hidden');
            
            var ownerPassword = $('#new_password').val(),
            ownerRepeatPassword = $('#confirm_password').val(),
            
            // allow only printable characters from latin-1
            regex = /^[\u0021-\u007e|\u00a1-\u00ff]+$/;

            if (ownerPassword == '' && ownerRepeatPassword == '') {
                $('.new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter permission password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#new_password').css('border-color', '#dd4b39');

                $('.confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter permission password'))
                    .parents('.form-group')
                    .addClass('has-error');
                $('#confirm_password').css('border-color', '#dd4b39');
                
                return false;
            } else if (ownerPassword == '') {
                $('.confirm_passwordErr').addClass('hidden');
                $('#confirm_password').css('border-color', '');

                $('.new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Enter permission password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#new_password').css('border-color', '#dd4b39');
                
                return false;
            } else if (ownerRepeatPassword == '') {
                $('.new_passwordErr').addClass('hidden');
                $('#new_password').css('border-color', '');

                $('.confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Re-enter permission password'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (ownerPassword != '' && ownerRepeatPassword != '' && ownerPassword !== ownerRepeatPassword) {
                $('.new_passwordErr').addClass('hidden');
                $('#new_password').css('border-color', '');

                $('.confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Permission passwords did not match'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (ownerPassword.length > 32) {
                $('.confirm_passwordErr').addClass('hidden');
                $('#confirm_password').css('border-color', '');

                $('.new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please enter permission password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#new_password').css('border-color', '#dd4b39');

                return false;
            } else if (ownerRepeatPassword.length > 32) {
                $('.new_passwordErr').addClass('hidden');
                $('#new_password').css('border-color', '');

                $('.confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Please repeat permission password with up to 32 characters'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (ownerPassword != '' && ownerRepeatPassword != '' && ownerPassword !== ownerRepeatPassword) {
                $('.new_passwordErr').addClass('hidden');
                $('#new_password').css('border-color', '');

                $('.u_confirm_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Permission password did not match'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#confirm_password').css('border-color', '#dd4b39');

                return false;
            } else if (!regex.test(ownerPassword) == true) {
                $('.new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Invalid password. Only uppercase and lowercase characters, numbers, hyphens and underscores allowed.'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#new_password').css('border-color', '#dd4b39');

                $('.confirm_passwordErr').addClass('hidden');
                $('#confirm_password').css('border-color', '');

                return false;
            } else if (ownerPassword != '' && ownerPassword == $('#u_new_password').val()) {
                $('.new_passwordErr')
                    .removeClass('hidden')
                    .html(Translator.trans('Permission password and open password can not be the same.'))
                    .parents('.form-group')
                    .addClass('has-error')
                    .get(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
                $('#new_password').css('border-color', '#dd4b39');

                $('.u_confirm_passwordErr').addClass('hidden');
                $('#u_confirm_password').css('border-color', '');
                
                return false;
            } else {
                pwdOwnerSuccess = true;
                return true;
            }
        }
    });
}
